/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
  InputNumber,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import { getEstadosGlobales } from 'api/catalogos/index';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import { formatReceived } from 'utils/formatValues';
import { getTiposDeContrataciones } from 'api/catalogos/tiposDeContrataciones';
import { ModelConfiguradorNombramientosFormato } from 'api/catalogos/ConfiguradorNombramientosFormato';

const modelPermissionName = 'clase';
export const ConfiguradorNombramientosFormatoPermission = {
  permissionModel: modelPermissionName,
  catalogsModels: [],
  tabsModels: [],
};

const ConfiguradorNombramientosFormato = ({ permission, setUpdateTable /* , IdParent */ }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const nameNoDeReporte = 'no_de_reporte';

  const {
    cliente,
    nameModel,
    nameModelSingular,
    formatter,
  } = ModelConfiguradorNombramientosFormato;
  const registroName = '';

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros();/* (
      {
      nombramiento: IdParent,
    } ); */
    setData(formatReceived(_data));
    if (typeof setUpdateTable === 'function') setUpdateTable((prev) => !prev);
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _data,
        _estados,
      ] = await Promise.all([
        cliente.obtenerListaDeRegistros(),
        getEstadosGlobales(),
        getTiposDeContrataciones(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _regristo = await cliente.obtenerUnRegistro(match.id);

    setTimeout(() => {
      if (_regristo) {
        const formValues = formatter.formatRecordForRead(_regristo);
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_regristo?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const valuesForm = form.getFieldsValue();
      const [key] = selectedRowKeys;

      const values = formatter.formatRecordForSend(valuesForm);
      const saved = await (key
        ? cliente.actualizarRegistro(key, values)
        : cliente.crearRegistro(values)
      );
      if (saved) {
        if (_continue) {
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
        }
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await cliente.borrarRegistro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = formatter.formatRecordForRead(record);

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, `No se puede autorizar ${nameModelSingular} ya autorizado`);
        return;
      }
      const saved = await cliente.autorizarRegistro(key);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'No. de Reporte',
      dataIndex: nameNoDeReporte,
      key: nameNoDeReporte,
      width: 200,
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'vigencia_inicial',
      key: 'vigencia_inicial',
      width: 150,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : ''),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : ''),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (id) => estados?.find((_Record) => _Record?.id === id)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'clase', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} ${nameModel} `}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name={nameNoDeReporte}
                  rules={rules.required}
                  label="No. de Reporte"
                  hasFeedback
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_inicial"
                  label="Vigencia Inicial"
                  rules={rules.required}
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    placeholder=""
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    placeholder=""
                    disabled={isAdding || selectedData?.estados_globales === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    disabled
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="nombramiento"
                  label="Parent Id"
                  hasFeedback
                  hidden
                >
                  <Input
                    hidden
                    defaultValue={IdParent}
                  />
                </Form.Item>
              </Col> */}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`${nameModelSingular} ${registroName}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar ${nameModelSingular} ${registroName}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar ${nameModelSingular} ${registroName}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default ConfiguradorNombramientosFormato;
